(() => {
  if (customElements.get('mareld-size-alternatives')) return;
  const targets = new Map();
  const normalise = raw => {
    let value = String(raw).trim().toUpperCase().replace(/\s+/g, ' ');
    if (/^(UNIVERSAL|UNI|ONE[ -]?SIZE|EINHEITSGRÖSSE)$/.test(value)) return 'EINHEITSGRÖSSE';
    if (/^X{2,}L$/.test(value)) value = `${value.length - 1}XL`;
    return value;
  };
  const loadFilters = target => {
    if (!targets.has(target)) {
      targets.set(target, fetch(target, {credentials:'same-origin'}).then(response => {
        if (!response.ok) throw new Error('Filter page unavailable');
        return response.text();
      }).then(html => {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const stock = parsed.querySelector('input[name="filter.v.availability"]');
        if (!stock) return [];
        const values = [];
        parsed.querySelectorAll('select[data-size-select] option, input[name^="filter.v.option."], input[name="filter.v.t.shopify.color-pattern"]').forEach(input => {
          const parameter = input.closest('select')?.name || input.name;
          const kind = /^filter\.v\.option\.(größe|groesse|size)$/i.test(parameter || '') ? 'size' : parameter === 'filter.v.t.shopify.color-pattern' ? 'color' : '';
          if (!kind) return;
          const label = input.tagName === 'OPTION' ? input.textContent : parsed.getElementById(input.id)?.nextElementSibling?.querySelector('.reversed-link__text')?.textContent;
          if (!label || !input.value) return;
          values.push({parameter, value:input.value, label:normalise(label), kind});
        });
        return values;
      }).catch(() => []));
    }
    return targets.get(target);
  };
  const normalType = value => String(value || '').trim().toLowerCase().replace(/\s+/g,' ');
  const colourFamily = raw => {
    const text = normalType(raw).replace(/\d+$/,'').trim();
    const families = [ ['black',/schwarz|black/],['white',/weiß|weiss|white|creme|cream|ecru|elfenbein/],['brown',/braun|brown|cognac|camel|schoko|chocolate/],['beige',/beige|sand|taupe|nude/],['blue',/blau|blue|navy/],['green',/grün|gruen|green|olive|khaki/],['red',/rot|red|bordeaux|burgund/],['pink',/rosa|pink|rosé|rose/],['purple',/lila|violett|purple/],['grey',/grau|grey|gray|anthrazit|silver|silber/],['gold',/gold/],['yellow',/gelb|yellow/],['orange',/orange|koralle|coral/] ];
    return families.find(([,pattern])=>pattern.test(text))?.[0] || '';
  };
  const colourScore = (source, candidate) => {
    if (!source || !candidate) return 0;
    if (normalType(source) === normalType(candidate)) return 45;
    const a=colourFamily(source),b=colourFamily(candidate);
    if (a && a===b) return 35;
    return [['brown','beige'],['white','beige'],['black','grey'],['pink','red']].some(pair=>pair.includes(a)&&pair.includes(b)) ? 12 : 0;
  };
  const styleRules = [
    ['cut','wrap',/wickel/],['cut','aline',/a[ -]?linie/],['cut','fitted',/figurbetont|bodycon|tailliert/],['cut','wide',/wide[ -]?leg|weite[ nr]? beine|palazzo/],['cut','culotte',/culotte/],['cut','pencil',/bleistift/],
    ['length','maxi',/maxi/],['length','midi',/midi/],['length','mini',/mini/],
    ['sleeve','long',/langarm|langen? ärmel|langärml/],['sleeve','short',/kurzarm|kurzen? ärmel|kurzärml/],['sleeve','none',/ärmellos|aermellos/],
    ['neck','v',/v[ -]?ausschnitt/],['neck','round',/rundhals/],['neck','boat',/boot[s]?ausschnitt/],['neck','halter',/neckholder/],['neck','offshoulder',/carmen|off[ -]?shoulder/],
    ['pattern','floral',/blumen|floral|blüten/],['pattern','dots',/polka|punkte|gepunkt/],['pattern','stripes',/streifen|gestreift/],['pattern','check',/karo/],['pattern','animal',/leopard|animal|zebra/],['pattern','plain',/unifarben|einfarbig/],
    ['material','satin',/satin/],['material','velvet',/samt|velours/],['material','denim',/denim|jeans/],['material','linen',/leinen/],['material','cotton',/baumwoll/],
    ['detail','lace',/spitze|spitzen/],['detail','ruffle',/rüschen|rueschen|volant/],['detail','pleat',/plissee|faltenrock/],['detail','belt',/gürtel|guertel|bindeband/],
    ['occasion','sport',/sportlich|sport/],['occasion','festive',/festlich|cocktail|abendkleid/],['occasion','boho',/boho/],
    ['support','pushup',/push[ -]?up/],['support','soft',/soft[ -]?bh|ungepolstert/],['support','underwire',/bügel|buegel/],['support','padded',/gepolstert/],
    ['heel','block',/blockabsatz/],['heel','stiletto',/stiletto|pfennigabsatz/],['heel','flat',/flache[rn]? absatz|ohne absatz/],['toe','pointed',/spitze[rn]? spitze|spitze[rn]? zehen|spitzer spitze/],['toe','round',/runde[rn]? spitze/],
    ['jewel','pearl',/perlen/],['jewel','heart',/herz/],['jewel','stone',/strass|zirkonia|edelstein/]
  ];
  const plainText = text => new DOMParser().parseFromString('<html><body>'+String(text || '')+'</body></html>','text/html').body.textContent.toLowerCase();
  const features = text => { const plain=plainText(text); return new Set(styleRules.filter(([, ,pattern])=>pattern.test(plain)).map(([group,value])=>`${group}:${value}`)); };
  const styleScore = (source, candidate) => {
    const a=features(source),b=features(candidate);let score=0;
    for(const feature of a) {
      if(b.has(feature)) score+=feature.startsWith('cut:')?18:9;
      else if(Array.from(b).some(other=>other.split(':')[0]===feature.split(':')[0])) score-=6;
    }
    return score;
  };
  const optionIndex = (product,kind) => (product.options || []).findIndex(option => {
    const name=normalType(typeof option==='string'?option:option.name);
    return kind==='size'?['größe','groesse','size','größen'].includes(name):['farbe','color','colour'].includes(name);
  });
  const chooseVariant = (product,size,colour) => {
    const sizeIndex=optionIndex(product,'size'),colorIndex=optionIndex(product,'color');
    if(sizeIndex<0) return null;
    const choices=(product.variants || []).filter(variant=>variant.available===true && normalise(variant.options?.[sizeIndex])===normalise(size));
    choices.sort((a,b)=>colourScore(colour,b.options?.[colorIndex])-colourScore(colour,a.options?.[colorIndex]) || Number(a.price)-Number(b.price));
    for(const variant of choices) {
      const image=variant.featured_image?.src || variant.featured_image?.url || (typeof variant.featured_image==='string'?variant.featured_image:'');
      const colours=new Set((product.variants || []).map(v=>v.options?.[colorIndex]).filter(Boolean));
      const fallback=typeof product.featured_image==='string'?product.featured_image:product.featured_image?.src;
      const selectedImage=image || (colours.size<=1 ? fallback : '');
      if(selectedImage) return {variant,image:selectedImage,colour:variant.options?.[colorIndex] || ''};
    }
    return null;
  };
  const fetchJSON = url => fetch(url,{credentials:'same-origin',cache:'no-store'}).then(response=>{if(!response.ok)throw Error('Unavailable');return response.json();});
  const relatedCache=new Map();
  const relatedProducts = id => {
    if(!relatedCache.has(id)) relatedCache.set(id,fetchJSON(`${window.Shopify?.routes?.root || '/'}recommendations/products.json?product_id=${encodeURIComponent(id)}&limit=10&intent=related`).then(data=>data.products || []).catch(()=>[]));
    return relatedCache.get(id);
  };
  const candidateCache=new Map();
  const collectionCandidates = target => {
    const url=new URL(target,window.location.origin);
    if(!url.pathname.includes('/collections/'))return Promise.resolve([]);
    url.searchParams.set('section_id','mareld-alternative-candidates');
    const key=url.href;
    if(!candidateCache.has(key))candidateCache.set(key,fetch(key,{credentials:'same-origin'}).then(r=>r.ok?r.text():Promise.reject()).then(html=>JSON.parse(new DOMParser().parseFromString(html,'text/html').querySelector('[data-mareld-candidates]')?.textContent || '{}').products || []).catch(()=>[]));
    return candidateCache.get(key);
  };
  class MareldSizeAlternatives extends HTMLElement {
    connectedCallback() {
      Promise.resolve().then(() => window.MareldRecommendationTracking?.refresh());
      if (this.started) return;
      this.started = true;
      queueMicrotask(() => {
        if (!this.isConnected) { this.started = false; return; }
        this.picker = this.closest('variant-selects');
        if (!this.picker) return;
        this.onChange = () => { this.hidden = true; this.schedule(); };
        this.onVariant = () => this.schedule();
        this.picker.addEventListener('change', this.onChange);
        document.addEventListener('variant:changed', this.onVariant);
        this.observer = new MutationObserver(records => {
          if (records.some(record => !this.contains(record.target))) this.schedule();
        });
        this.observer.observe(this.picker, {childList:true,subtree:true,attributes:true,attributeFilter:['checked','selected']});
        this.refresh();
      });
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.picker?.removeEventListener('change', this.onChange);
      document.removeEventListener('variant:changed', this.onVariant);
      this.started = false;
      this.token = (this.token || 0) + 1;
    }
    schedule() {
      if (this.pending) return;
      this.pending = true;
      queueMicrotask(() => { this.pending = false; if (this.isConnected) this.refresh(); });
    }
    currentVariant() {
      const names = JSON.parse(this.dataset.optionNames);
      const selected = names.map(name => {
        const radio = Array.from(this.picker.querySelectorAll('input[type="radio"]')).find(input => input.dataset.optionName === name && input.checked);
        if (radio) return radio.value;
        const select = Array.from(this.picker.querySelectorAll('select')).find(input => input.name === `options[${name}]` || Array.from(input.options).some(option => option.dataset.optionName === name));
        return select?.value;
      });
      if (selected.some(value => value == null)) return null;
      const match = variant => variant && Array.isArray(variant.options) && variant.options.length === selected.length && variant.options.every((value,index) => String(value) === selected[index]);
      try {
        const cached = JSON.parse(this.picker.querySelector('[data-variants-cache]')?.textContent || '[]').find(match);
        if (cached) return cached;
        const current = JSON.parse(this.picker.querySelector('[data-selected-variant]')?.textContent || 'null');
        return match(current) ? current : null;
      } catch (_) { return null; }
    }
    async showCards(sourceVariant, size, target, token) {
      const names=JSON.parse(this.dataset.optionNames);
      const colorIndex=names.findIndex(name=>['farbe','color','colour'].includes(normalType(name)));
      const colour=sourceVariant.options[colorIndex] || '';
      const sourcePrice=Number(sourceVariant.price || this.dataset.price);
      const sourceType=normalType(this.dataset.productType);
      if(!sourceType)return;
      const [related,category]=await Promise.all([relatedProducts(this.dataset.productId),collectionCandidates(target)]);
      if(token!==this.token || !this.isConnected)return;
      const candidates=new Map();
      for(const product of [...related,...category]) {
        if(String(product.id)===this.dataset.productId || normalType(product.type)!==sourceType || !product.handle || !/^[a-z0-9-]+$/.test(product.handle))continue;
        candidates.set(String(product.id),product);
      }
      const score=(product,price,color)=> {
        const difference=sourcePrice>0?Math.abs(price-sourcePrice)/sourcePrice:0;
        return colourScore(colour,color)+styleScore(this.dataset.productFeatures,`${product.title} ${product.description || ''} ${(product.tags || []).join(' ')}`)+(product.vendor===this.dataset.productVendor?3:0)+Math.max(0,10-difference*15);
      };
      const ranked=Array.from(candidates.values()).map(product=>{
        let colors=product.colors || [];
        const ix=optionIndex(product,'color');
        if(ix>=0)colors=(product.variants || []).map(v=>v.options?.[ix]);
        return {product,score:score(product,Number(product.price || 0),colors.sort((a,b)=>colourScore(colour,b)-colourScore(colour,a))[0] || '')};
      }).sort((a,b)=>b.score-a.score).slice(0,20);
      const confirmed=[];
      for(let start=0;start<ranked.length;start+=4) {
        if(token!==this.token || !this.isConnected)return;
        const group=await Promise.all(ranked.slice(start,start+4).map(async ({product})=>{
          try {
            const live=await fetchJSON(`${window.Shopify?.routes?.root || '/'}products/${product.handle}.js`);
            if(String(live.id)!==String(product.id)||normalType(live.type)!==sourceType||live.requires_selling_plan)return null;
            const choice=chooseVariant(live,size,colour);
            return choice?{product:live,...choice,score:score(live,Number(choice.variant.price),choice.colour)}:null;
          }catch(_){return null;}
        }));
        confirmed.push(...group.filter(Boolean));
        // Verify the short list before ranking final cards; availability is never inferred from product-level stock.
      }
      if(token!==this.token || !this.isConnected)return;
      confirmed.sort((a,b)=>b.score-a.score);
      const grid=this.querySelector('[data-msa-grid]');grid.replaceChildren();
      const currency=this.dataset.currency || 'EUR';
      for(const item of confirmed.slice(0,4)) {
        const card=document.createElement('a');card.className='msa-card product-card';card.dataset.productId=String(item.product.id);card.dataset.variantId=String(item.variant.id);
        const url=new URL(`${window.Shopify?.routes?.root || '/'}products/${item.product.handle}`,window.location.origin);url.searchParams.set('variant',String(item.variant.id));card.href=url.href;
        const image=document.createElement('img');image.src=item.image;image.alt=`${item.product.title} – ${item.colour}`;image.loading='lazy';image.width=300;image.height=400;card.append(image);
        const text=(tag,cls,value)=>{const node=document.createElement(tag);node.className=cls;node.textContent=value;card.append(node);};
        text('span','product-card__vendor',item.product.vendor);
        text('h4','product-card__title',item.product.title);
        text('p','msa-card__variant',`${normalise(size)==='EINHEITSGRÖSSE'?'Einheitsgröße':size}${item.colour?' · '+item.colour:''}`);
        text('p','msa-card__price',new Intl.NumberFormat('de-DE',{style:'currency',currency}).format(Number(item.variant.price)/100));
        grid.append(card);
      }
      this.querySelector('[data-msa-results]').hidden=!grid.children.length;
    }
    async refresh() {
      this.querySelector('[data-msa-results]').hidden = true;
      const token = this.token = (this.token || 0) + 1;
      const variant = this.currentVariant();
      if (!variant || variant.available !== false) { this.hidden = true; return; }
      const size = variant.options[Number(this.dataset.sizeIndex)];
      if (!size) { this.hidden = true; return; }
      const link = this.querySelector('[data-alternative-link]');
      link.href = this.dataset.target;
      link.textContent = 'Ähnliche Artikel ansehen';
      this.hidden = false;
      const values = await loadFilters(this.dataset.target);
      if (!this.isConnected || token !== this.token) return;
      const matches = values.filter(value => value.kind === 'size' && value.label === normalise(size));
      if (!matches.length) { await this.showCards(variant, size, this.dataset.target, token); return; }
      const url = new URL(this.dataset.target, window.location.origin);
      const parameter = matches[0].parameter;
      if (matches.some(value => value.parameter !== parameter)) return;
      url.searchParams.delete(parameter);
      for (const value of new Set(matches.map(value => value.value))) url.searchParams.append(parameter, value);
      url.searchParams.set('filter.v.availability','1');
      const displaySize = normalise(size) === 'EINHEITSGRÖSSE' ? 'Einheitsgröße' : size;
      link.href = url.href;
      link.textContent = `Weitere Artikel in ${displaySize} ansehen`;
      const names=JSON.parse(this.dataset.optionNames);
      const colorIndex=names.findIndex(name=>['farbe','color','colour'].includes(normalType(name)));
      const sourceColour=variant.options[colorIndex] || '';
      const colourMatches=values.filter(value=>value.kind==='color' && colourScore(sourceColour,value.label)>=35);
      const candidateURL=new URL(url.href);
      for(const value of new Set(colourMatches.map(value=>value.value)))candidateURL.searchParams.append('filter.v.t.shopify.color-pattern',value);
      await this.showCards(variant, size, candidateURL.href, token);
    }
  }
  customElements.define('mareld-size-alternatives', MareldSizeAlternatives);
})();

/* MARELD recommendation events v1. No cookies, storage or direct analytics requests. */
(() => {
  if (window.MareldRecommendationTracking) return;
  const selector = 'mareld-complete-look, mareld-size-alternatives';
  const cardSelector = '[data-look-card], .msa-card';
  const roots = new Map();
  const publish = (name, data) => {
    if (window.Shopify?.designMode || typeof window.Shopify?.analytics?.publish !== 'function') return false;
    try { Promise.resolve(window.Shopify.analytics.publish(`mareld:${name}`, data)).catch(() => {}); return true; }
    catch { return false; }
  };
  const dataFor = (root, card, clickedLink) => {
    const link = clickedLink || (card.matches('a[href]') ? card : card.querySelector('a[href*="/products/"]'));
    if (!link) return null;
    let url;
    try { url = new URL(link.href, window.location.origin); } catch { return null; }
    if (url.origin !== window.location.origin) return null;
    const handle = url.pathname.match(/\/products\/([^/]+)/)?.[1];
    if (!handle) return null;
    let sourceId = root.dataset.productId || root.dataset.product || '';
    try { sourceId = JSON.parse(root.querySelector('[data-look-source]')?.textContent || '{}').id || sourceId; } catch {}
    const main = document.querySelector('product-info[id^="MainProduct"]');
    sourceId = sourceId || main?.dataset.productId || '';
    const list = root.localName === 'mareld-complete-look' ? 'complete_look' : 'size_alternatives';
    const cards = [...root.querySelectorAll(cardSelector)];
    return {schema_version: 1, recommendation_list: list, source_product_id: String(sourceId),
      product_id: String(card.dataset.productId || ''), product_handle: handle,
      variant_id: String(card.dataset.variantId || url.searchParams.get('variant') || ''),
      position: cards.indexOf(card) + 1};
  };
  const attach = root => {
    if (roots.has(root)) return;
    const seen = new Set(), timers = new Map(), watched = new Set();
    const stopTimer = card => { clearTimeout(timers.get(card)); timers.delete(card); };
    const visible = card => {
      const rect = card.getBoundingClientRect();
      const intersection = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0)) *
        Math.max(0, Math.min(rect.right, window.innerWidth) - Math.max(rect.left, 0));
      return card.isConnected && rect.width > 0 && rect.height > 0 && intersection / (rect.width * rect.height) >= .5;
    };
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      for (const entry of entries) {
        const card = entry.target;
        stopTimer(card);
        if (!entry.isIntersecting || entry.intersectionRatio < .5 || document.visibilityState === 'hidden') continue;
        timers.set(card, setTimeout(() => {
          timers.delete(card);
          if (document.visibilityState === 'hidden' || !visible(card)) return;
          const data = dataFor(root, card);
          if (!data) return;
          const key = `${data.product_handle}:${data.variant_id}`;
          if (!seen.has(key) && publish('recommendation_view', data)) seen.add(key);
        }, 1000));
      }
    }, {threshold: [.5]}) : null;
    const scan = () => {
      for (const card of watched) if (!card.isConnected) { observer?.unobserve(card); stopTimer(card); watched.delete(card); }
      for (const card of root.querySelectorAll(cardSelector)) if (!watched.has(card)) { watched.add(card); observer?.observe(card); }
    };
    const mutation = new MutationObserver(scan);
    mutation.observe(root, {childList: true, subtree: true});
    const click = event => {
      const link = event.target.closest?.('a[href]');
      if (!link || !root.contains(link)) return;
      try {const url = new URL(link.href, window.location.origin); if (url.origin !== window.location.origin || !/\/products\/[^/]+/.test(url.pathname)) return;} catch {return;}
      const card = link.closest(cardSelector);
      if (!card || !(card === link || card.contains(link))) return;
      const data = dataFor(root, card, link);
      if (data) publish('recommendation_click', data);
    };
    root.addEventListener('click', click);
    roots.set(root, {cleanup() { mutation.disconnect(); observer?.disconnect(); timers.forEach(clearTimeout); root.removeEventListener('click', click); }});
    scan();
  };
  const init = () => {
    for (const [root, state] of roots) if (!root.isConnected) {state.cleanup(); roots.delete(root);}
    document.querySelectorAll(selector).forEach(attach);
  };
  window.MareldRecommendationTracking = {version: 1, refresh: init};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', () => setTimeout(init, 0));
})();
